module.exports = __webpack_public_path__ + "img/138.fc62da45.jpg";